// extracted by mini-css-extract-plugin
export var buttons = "V_cD";
export var column = "V_bX";
export var columns = "V_bW";
export var container = "V_b";
export var down = "V_dj";
export var download = "V_dh";
export var footer = "V_ch";
export var information = "V_dg";
export var section = "V_d";
export var show = "V_L";
export var text = "V_b6";
export var title = "V_h";
export var units = "V_dk";
export var up = "V_dm";
export var upload = "V_dl";
export var waveOne = "V_q";
export var waveThree = "V_b5";
export var waveTwo = "V_n";
export var waves = "V_b4";